<div class="audit-header">
  <div [ngClass]="{ hidding: editable }" class="tips">
    Shared Template View Only
  </div>
  <div class="button-row">
    <button
      mat-button
      class="icon-only"
      (click)="backToHome()"
      matTooltip="Back to RegApply home"
      matTooltipClass="tooltip2"
    >
      <mat-icon>west</mat-icon>
    </button>
    <button
      class="normal-button"
      matTooltip="Save template"
      matTooltipClass="tooltip2"
      mat-button
      [disabled]="
        this.isLoading ||
        !this.editable ||
        !this.isSavable ||
        !isAuditNameValid()
      "
      (click)="onSaveTemplate()"
    >
      <mat-icon>save</mat-icon>
    </button>
    <button
      class="normal-button"
      matTooltip="delete template"
      matTooltipClass="tooltip2"
      mat-button
      [disabled]="csskey < 1 || this.isLoading || !this.editable"
      (click)="onDeleteTemplate()"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <button
      class="normal-button"
      matTooltip="Answer applicability screening questions"
      matTooltipClass="tooltip2"
      mat-button
      [disabled]="csskey < 1 || this.isLoading"
      (click)="onBuildApplicability()"
    >
      <mat-icon>assessment</mat-icon>
    </button>
    <button
      class="normal-button"
      matTooltip="Add to Outlook calendar"
      matTooltipClass="tooltip2"
      mat-button
      [disabled]="this.isLoading || csskey < 1"
      (click)="onAddEventToCalendar()"
    >
      <mat-icon>calendar_month</mat-icon>
    </button>
  </div>
</div>

<div class="contents">
  <mat-card class="template-header" [formGroup]="templateHead">
    <mat-card-title class="mat-primary mat-toolbar"
      >Audit Details</mat-card-title
    >

    <mat-card-content class="large">
      <mat-form-field appearance="fill" class="one-row">
        <mat-label>Audit Name</mat-label>
        <input
          matInput
          formControlName="auditName"
          maxlength="255"
          (input)="this.isSavable = true"
        />
        <mat-hint align="end"
          >{{ templateHead.get("auditName").value?.length || 0 }}/255</mat-hint
        >
      </mat-form-field>
      <mat-form-field appearance="fill" class="one-row">
        <mat-label>Facility</mat-label>
        <input
          matInput
          maxlength="50"
          formControlName="facilityName"
          (input)="isSavable = true"
        />
        <mat-hint align="end"
          >{{
            templateHead.get("facilityName").value?.length || 0
          }}/50</mat-hint
        >
      </mat-form-field>

      <div class="one-row">
        <AutocompleteComponent
          (setAddress)="getAddress($event)"
          addressType="geocode"
          [address]="formattedAddress"
        ></AutocompleteComponent>
      </div>

      <div class="one-row share-line">
        <mat-checkbox
          (change)="onDualChange($event)"
          [(ngModel)]="dualLanguageCheckbox"
          [checked]="dualLanguageCheckbox"
          class="share-checkbox"
          matTooltip="Include available dual language questions automatically."
          matTooltipClass="tooltip2"
          >Dual Language
        </mat-checkbox>
      </div>
      <div class="one-row share-line">
        <span
          class="share-checkbox"
          matTooltip="Share your template with all licensed users. Choose either View or Edit."
          matTooltipClass="tooltip2"
          >Share template:
        </span>
        <mat-radio-group
          class="share-template"
          [(ngModel)]="permission"
          [ngModelOptions]="{ standalone: true }"
          (change)="this.isSavable = true"
          color="primary"
        >
          <mat-radio-button
            color="primary"
            value="Not"
            [disabled]="this.isLoading || !this.editable"
            [checked]="permission == 'Not'"
            >No</mat-radio-button
          >
          <mat-radio-button
            color="primary"
            value="View"
            [disabled]="this.isLoading || !this.editable"
            [checked]="permission == 'View'"
            >View</mat-radio-button
          >
          <mat-radio-button
            color="primary"
            value="Edit"
            [disabled]="this.isLoading || !this.editable"
            [checked]="permission == 'Edit'"
            >Edit</mat-radio-button
          >
        </mat-radio-group>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <mat-form-field fxFlex="calc(50%-15px)">
          <mat-label>Audit Start Date</mat-label>
          <input
            (dateInput)="OnStartDateChange($event.value)"
            [disabled]="this.isLoading || !this.editable"
            matInput
            [matDatepicker]="picker1"
            placeholder="Audit Start Date"
            formControlName="startDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1 color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field fxFlex="calc(50%-15px)">
          <mat-label>Audit End Date</mat-label>
          <input
            matInput
            (dateInput)="onEndDateChange($event.value)"
            [matDatepicker]="picker2"
            [min]="startDateValue"
            [disabled]="this.isLoading || !this.editable"
            placeholder="Audit End Date"
            formControlName="endDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #picker2
            [startAt]="startDateValue"
            color="red"
          ></mat-datepicker>
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="topic-options">
    <div class="audit-rb">
      <ul class="nav nav-tabs">
        @for (ca of topics; track ca) {
        <li [class]="ca.category == currentCategory ? 'none' : 'panel-tab'">
          <a
            [routerLink]=""
            [class.disabled]="this.isLoading"
            [class]="ca.category == currentCategory ? 'selected' : 'none'"
            (click)="onCategoryChange(ca.category)"
          >
            {{ mapCategory(ca.category) }}
            @if (ca.selected > 0) {
            <p-badge
              [value]="ca.selected"
              severity="warn"
              class="upper"
            ></p-badge>

            }
          </a>
        </li>
        }
      </ul>
    </div>
    @for (ca of topics; track ca) {
    <div class="topic-contents">
      @if (ca.category == currentCategory) {
      <div class="accordion-item">
        @for (ac of ca.acronyms; track ac; let i = $index) {
        <mat-accordion class="accordion-item">
          <mat-expansion-panel
            class="accordion-content"
            [disabled]="this.isLoading"
            [expanded]="step === i"
            (opened)="setStep(i, ac.acronym)"
            (closed)="onPanelClosed(i)"
            hideToggle
          >
            <mat-expansion-panel-header class="panel-header">
              <mat-panel-title>
                {{ ac.title }}
                @if (ca.category !== 'Custom') { ({{ ac.releaseNum }}) } @if
                (ac.acronym === 'FIRE') {
                <a href="publications/OSHA/FIRE/FIRE_Intro.pdf" target="_blank"
                  >&nbsp;View State Adoption</a
                ><span class="serverMessage">*</span>
                }
              </mat-panel-title>
              <mat-panel-description class="badger-icon">
                @if (step === i) {
                <mat-checkbox
                  class="topic-check"
                  [checked]="
                    ac.topics ? ac.selected === ac.topics.length : false
                  "
                  (click)="onSelectAllClick($event)"
                  (change)="onSelectAllChange($event, ac.acronym)"
                  [disabled]="this.isLoading || !this.editable"
                  >Select All
                </mat-checkbox>
                } @if(ac.selected > 0) {
                <p-badge [value]="ac.selected" severity="warn"></p-badge>
                }
              </mat-panel-description>
            </mat-expansion-panel-header>
            @if (step === i) {
            <div class="checkbox-container">
              @for (tp of ac.topics; track tp) {
              <mat-checkbox
                class="topic-check"
                [(ngModel)]="tp.selected"
                [checked]="tp.selected"
                [disabled]="this.isLoading || !this.editable"
                (change)="
                  onTopicChange(tp, ac.title, ac.acronym, ac.releaseNum)
                "
                >{{ tp.topic }}
              </mat-checkbox>
              }
            </div>
            }
          </mat-expansion-panel>
        </mat-accordion>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
@if (service.loading) {
<div class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
}
